export default {"src":"/_next/static/media/offer-tag.f54e60b9.svg","height":37,"width":76};